import { DASHBOARD_POST_GAME_SEASON_API } from '../constants/routes';
import AuthService from './authservices';
import {
  PostGameSeasonErrorResponse,
  PostGameSeasonMutationResponse,
  PostGameSeasonRequest,
  PostGameSeasonResponse,
  PostGameSeasonWriteBody,
} from '../types/postGameSeason';

const authService = new AuthService();

function postGameSeasonUrl(
  username: string,
  selectedSport: string,
  season?: number
): URL {
  const requestUrl = new URL(DASHBOARD_POST_GAME_SEASON_API);
  requestUrl.searchParams.set('username', username);
  requestUrl.searchParams.set('selectedSport', selectedSport);
  if (season !== undefined && season !== null) {
    requestUrl.searchParams.set('season', String(season));
  }
  return requestUrl;
}

export const fetchPostGameSeason = async ({
  username,
  selectedSport,
  season,
}: PostGameSeasonRequest): Promise<PostGameSeasonResponse> => {
  const response = await authService.authenticatedFetch(
    postGameSeasonUrl(username, selectedSport, season).toString(),
    { method: 'GET', headers: { 'Content-Type': 'application/json' } }
  );
  if (!response.ok) {
    throw new Error('Failed to fetch post-game season data');
  }
  return response.json();
};

export const updatePostGameSeasonTag = async (
  { username, selectedSport }: PostGameSeasonRequest,
  flatMatchId: number,
  body: PostGameSeasonWriteBody
): Promise<PostGameSeasonMutationResponse | PostGameSeasonErrorResponse> => {
  const url = postGameSeasonUrl(username, selectedSport);
  url.pathname = `${url.pathname}/${flatMatchId}`;
  const response = await authService.authenticatedFetch(url.toString(), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const payload = await response.json();
  if (!response.ok) {
    return payload as PostGameSeasonErrorResponse;
  }
  return payload as PostGameSeasonMutationResponse;
};

export function isPostGameSeasonError(
  result: PostGameSeasonMutationResponse | PostGameSeasonErrorResponse
): result is PostGameSeasonErrorResponse {
  return result.success === false;
}
